import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './info-note.scss';

type Props = {
  children?: React.ReactNode,
  type?: 'info' | 'warning' | 'error',
  size?: 'small' | 'normal',
  hideIcon?: boolean,
  className?: string
};

const IconColorMap: {
  [type: string]: 'blue' | 'orange' | 'red'
} = {
  info: 'blue',
  warning: 'orange',
  error: 'red'
};

const InfoNote = ({
  children,
  type = 'info',
  size = 'small',
  hideIcon,
  className
}: Props): JSX.Element => {
  const baseClasses = classnames('info-note', className, {
    [`info-note--${type}`]: type
  });

  const contentSectionClasses = classnames('info-note__content-section', {
    [`info-note__content-section--size-${size}`]: size
  });

  return (
    <div className={baseClasses}>
      <div className={contentSectionClasses}>
        {children}
      </div>
      <div className="info-note__icon-section">
        {
          !hideIcon && (
            <SVGDynamicIcon
              name={
                type === 'error' ?
                  'exclamation-inside-circle-custom-bg'
                  : 'info-inside-circle-custom-bg'
              }
              width={16}
              height={16}
              customColor={IconColorMap[type]}
            />
          )
        }
      </div>
    </div>
  );
};

export default InfoNote;
